import { DemandeDevis } from '@/models/DemandeDevis';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { DEMANDE_DEVIS } from './mutation-types';
import { DemandeDevisState, initialState as resetState } from './state';

export const mutations: MutationTree<DemandeDevisState> = {
    [DEMANDE_DEVIS.SET_ITEMS](state, items: DemandeDevis[]) {
        state.demandesDevis = items;
    },
    [DEMANDE_DEVIS.RESET_ITEMS](state) {
        state.demandesDevis = [];
        state.page = 0;
        state.count = 0;
    },
    [DEMANDE_DEVIS.ADD_ITEMS](state, items: DemandeDevis[]) {
        state.demandesDevis = [...state.demandesDevis, ...items];
    },
    [DEMANDE_DEVIS.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [DEMANDE_DEVIS.REMOVE_ITEM](state, id: number) {
        state.demandesDevis = state.demandesDevis.filter(item => item.id !== id);
    },
    [DEMANDE_DEVIS.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [DEMANDE_DEVIS.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },

    [DEMANDE_DEVIS.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [DEMANDE_DEVIS.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [DEMANDE_DEVIS.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [DEMANDE_DEVIS.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [DEMANDE_DEVIS.SET_FILTER_SITE](state, siteList: Array<number>) {
        state.filterSite = siteList;
    },
    [DEMANDE_DEVIS.SET_FILTER_DEMANDE_DEVIS_ID](state, id: string) {
        state.filterDemandeDevisId = id;
    },
    [DEMANDE_DEVIS.SET_FILTER_ONLY_MINE](state, onlyMine: boolean) {
        state.filterMine = onlyMine;
    },
    [DEMANDE_DEVIS.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [DEMANDE_DEVIS.SET_ERROR](state, error: Error) {
        state.error = error;
    },
    [DEMANDE_DEVIS.CLEAR_ALL](state) {
        Object.assign(state, resetState);
    },
    [DEMANDE_DEVIS.SET_ATTACHMENT](state, attachment: any) {
        state.attachment = attachment;
    },
    [DEMANDE_DEVIS.SET_ATTACHMENT_TYPE](state, type: string) {
        state.attachmentType = type;
    },
    [DEMANDE_DEVIS.SET_ATTACHMENT_LOADING](state, loading: boolean) {
        state.isAttachmentLoading = loading;
    },
    [DEMANDE_DEVIS.SET_FILTER_DEMANDE_DEVIS_STATUS_LIST](state: DemandeDevisState, status: Array<string>) {
        state.filterStatus = status;
    },
    [DEMANDE_DEVIS.SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.isExportXlsLoading = isLoading;
    },
    [DEMANDE_DEVIS.UPDATE_OBJET](state, payload: { id: number, objet: string }) {
        const index = state.demandesDevis.findIndex(d => d.id === payload.id);
        if (index !== -1) {
            state.demandesDevis[index].objet = payload.objet;
        }
    }
};
